// extracted by mini-css-extract-plugin
module.exports = {"title":"TitlePage_title__2jth8","subTitle":"TitlePage_subTitle__3VYWM"};